import { useQuery } from "@tanstack/react-query";

import { HOUR } from "$src/core/constants/time";
import useApi from "$src/core/hooks/use-api";

const queryKey = () => ["epg-config"];

const STALE_TIME_30_MIN = HOUR / 2;
const CACHE_TIME_5H = HOUR * 5;

const useEPGConfigQuery = () => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(),
    staleTime: STALE_TIME_30_MIN,
    gcTime: CACHE_TIME_5H,
    queryFn: () => api.getEPGConfig(),
  });
};

export default useEPGConfigQuery;
